import { render, staticRenderFns } from "./SuccessFlashModal.vue?vue&type=template&id=5847d166"
import script from "./SuccessFlashModal.vue?vue&type=script&lang=js"
export * from "./SuccessFlashModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports